export const normalizeMatterRecord = (value) => value?.record || value || {};

export const getMatterIdFromPath = (...paths) => {
  const candidates = paths.filter(Boolean);
  for (const path of candidates) {
    const match = String(path).match(/\/matters?\/([^/?#]+)/i);
    if (match?.[1]) return decodeURIComponent(match[1]);
  }
  return null;
};

const addMatterId = (ids, value) => {
  if (value == null || value === "") return;
  if (typeof value === "object") {
    addMatterId(ids, value.id);
    addMatterId(ids, value.sf_id);
    addMatterId(ids, value.sf_matter_id);
    addMatterId(ids, value.matter_id);
    addMatterId(ids, value.matterId);
    return;
  }
  ids.add(String(value));
};

export const collectMatterIds = (...values) => {
  const ids = new Set();
  for (const value of values) addMatterId(ids, value);
  return ids;
};

export const isCurrentMatter = (currentId, ...known) => {
  if (currentId == null || currentId === "") return false;
  return collectMatterIds(...known).has(String(currentId));
};

export const getMatterIdFromTree = (nodes) => {
  if (!Array.isArray(nodes)) return null;
  for (const node of nodes) {
    const record = normalizeMatterRecord(node);
    const candidate =
      record.matter_id ||
      record.matter ||
      record.sf_matter_id ||
      record.sf_id ||
      record.matterId ||
      record.matter_id_nonexist;
    if (candidate) return candidate;
    const childCandidate = Array.isArray(node?.children)
      ? getMatterIdFromTree(node.children)
      : null;
    if (childCandidate) return childCandidate;
  }
  return null;
};

export const resolveMatterId = ({
  currentRecord,
  matterDetails,
  explicitMatterId,
  routeId,
  location,
  treeData,
} = {}) => {
  const record = normalizeMatterRecord(currentRecord);
  return (
    record.matter_id ||
    record.matter ||
    record.sf_matter_id ||
    record.sf_id ||
    matterDetails?.sf_id ||
    matterDetails?.sf_matter_id ||
    explicitMatterId ||
    getMatterIdFromPath(
      location?.pathname,
      globalThis.location?.pathname,
      globalThis.location?.href,
    ) ||
    routeId ||
    getMatterIdFromTree(treeData) ||
    (!matterDetails?.folder ? matterDetails?.id : null)
  );
};

export const getFolderIdentifier = (node) => {
  const record = normalizeMatterRecord(node);
  return (
    record.unique_id ||
    record.folder_id ||
    record.id ||
    node?.key ||
    null
  );
};
